export const getHandlesPrice = (order, prices) => {
  const {
    orderType,
    milledHandle,
    milledPartHandle,
    handlesMilledBy,
    items,
  } = order;
  const {
    services: { handle, partHandle, paintHandle, paintPartHandle },
  } = prices;

  if (orderType.toLowerCase() === 'reklamacja (wina dillak)') return 0;
  if (
    ['materiał klienta', ' poprawa (wina klienta)'].includes(
      orderType.toLowerCase(0),
    )
  ) {
    //  milled by dillak
    if (handlesMilledBy === 'dillak')
      return milledHandle * handle + milledPartHandle * partHandle;

    // order includes items from dillak
    if (items.some(item => item.dillakMaterial)) {
      const values = {
        dillak: { handle: 0, part: 0 },
        customer: { handle: 0, part: 0 },
      };
      items.forEach(item => {
        if (item.dillakMaterial) {
          values.dillak.handle += item.milledHandle || 0;
          values.dillak.part += item.milledPartHandle || 0;
        } else {
          values.customer.handle += item.milledHandle || 0;
          values.customer.part += item.milledPartHandle || 0;
        }
      });
      return (
        values.dillak.handle * handle +
        values.dillak.part * partHandle +
        values.customer.handle * paintHandle +
        values.customer.part * paintPartHandle
      );
    }
    return milledHandle * paintHandle + milledPartHandle * paintPartHandle;
  }

  return milledHandle * handle + milledPartHandle * partHandle;
};
